{
  "breadcrumbAriaLabel": "탐색 경로",
  "homeAriaLabel": "홈",
  "mainNavAriaLabel": "주 탐색",
  "closeSidebarAriaLabel": "사이드바 닫기",
  "collapse": "접기",
  "help": "도움말",
  "settings": "설정",
  "myProfile": "내 프로필",
  "groups": {
    "clinical": "임상",
    "worklists": "작업 목록",
    "documentation": "진료 문서",
    "orders": "처방",
    "medications": "약물",
    "scheduling": "예약 관리",
    "billing": "청구",
    "analytics": "분석",
    "organization": "조직",
    "security": "보안",
    "accessReviews": "Access Reviews",
    "integrations": "연동",
    "system": "시스템",
    "licensing": "라이선스"
  },
  "dashboard": "대시보드",
  "patients": "환자",
  "patientSearch": "환자 검색",
  "myPatients": "담당 환자",
  "censusBedBoard": "재원 / 병상 현황",
  "providerDirectory": "의료진 디렉터리",
  "providerCoverage": "의료진 당직 배정",
  "patientMerge": "환자 정보 병합",
  "inbox": "받은 편지함",
  "pendingResults": "미확인 결과",
  "criticalResults": "위급 결과",
  "unsignedNotes": "미서명 노트",
  "cosignQueue": "공동 서명 대기열",
  "noteTemplates": "노트 템플릿",
  "smartPhrases": "스마트 문구",
  "orderCatalog": "처방 카탈로그",
  "orderSets": "처방 세트",
  "encounters": "진료 기록",
  "orders": "처방",
  "results": "검사 결과",
  "medications": "약물",
  "notes": "진료 노트",
  "medicationWorklist": "Medication Worklist",
  "formulary": "원내 의약품",
  "pharmacistQueue": "약사 검토 대기열",
  "appointments": "예약",
  "scheduleManagement": "스케줄 관리",
  "waitlist": "대기 목록",
  "charges": "청구 항목",
  "claims": "보험 청구",
  "payments": "수납",
  "accounts": "계정",
  "statements": "명세서",
  "denials": "지급 거절",
  "analyticsDashboard": "대시보드",
  "reports": "보고서",
  "qualityMeasures": "질 평가 지표",
  "healthSystems": "의료 법인",
  "facilities": "의료기관",
  "locations": "위치",
  "clinicalTaxonomy": "임상 분류",
  "serviceLocation": "서비스 ↔ 위치",
  "providers": "의료진",
  "users": "사용자",
  "roles": "역할",
  "accessMatrix": "권한 매트릭스",
  "integrations": "연동",
  "thirdPartyApps": "외부 앱",
  "audit": "감사",
  "system": "시스템",
  "cdsRules": "CDS 규칙",
  "escalationRules": "Escalation Rules",
  "segments": {
    "search": "검색",
    "register": "등록",
    "demographics": "기본 정보",
    "census": "재원",
    "discharge": "퇴원",
    "catalog": "카탈로그",
    "sets": "처방 세트",
    "pending": "대기 중",
    "critical": "위급",
    "reconciliation": "약물 조정",
    "worklist": "작업 목록",
    "templates": "템플릿",
    "smartPhrases": "스마트 문구",
    "schedule": "스케줄 관리",
    "quality": "질 평가 지표",
    "administration": "관리",
    "auditLog": "감사 로그",
    "allergies": "알레르기",
    "problems": "문제 목록",
    "immunizations": "예방접종",
    "insurance": "보험"
  },
  "handoffs": "인계",
  "duplicateReview": "중복 검토",
  "sso": "SSO & Directories",
  "userGroups": "User Groups",
  "fileKey": "File key",
  "ordersWorklist": "오더 작업 목록"
}
